import { Dynamic } from './Dynamic';

export const HeroDynamic = () => {
    return <Dynamic componentKey="hero" />;
};
